import { Route, Routes } from 'react-router-dom';
import { GymMainPage } from '../pages/gym/GymMainPage';

export const GymRouter = () => {
    return (

        <Routes>

            <Route path='/' element={<GymMainPage />} />

        </Routes>

    );
};
